import React, { useState } from 'react';
import { api } from '../lib/api';
import './FileUpload.css';

interface FileUploadProps {}

const FileUpload: React.FC<FileUploadProps> = () => {
  const [file, setFile] = useState<File | null>(null);
  const [fileType, setFileType] = useState<'justo' | 'uber'>('justo');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      // Check file type
      if (!selectedFile.name.match(/\.(xls|xlsx)$/)) {
        setError('Por favor seleccione un archivo Excel (.xls o .xlsx)');
        setFile(null);
        return;
      }
      
      // Check file size (10MB limit)
      if (selectedFile.size > 10 * 1024 * 1024) {
        setError('El archivo no debe exceder 10MB');
        setFile(null);
        return;
      }
      
      setFile(selectedFile);
      setError('');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) {
      setError('Por favor seleccione un archivo');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    const response = await api.uploadFile(file, fileType);

    if (response.ok && response.data) {
      setMessage(`Archivo procesado exitosamente. ${response.data.processed_rows} filas procesadas.`);
      setFile(null);
      
      // Reset the file input
      const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } else {
      console.error('Error uploading file:', response.error);
      let errorMessage = response.error || 'Error desconocido al subir el archivo.';
      
      setError(errorMessage);
    }

    setLoading(false);
  };

  return (
    <div className="file-upload-container">
      <h2>Subir Archivo de Comentarios</h2>
      
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label htmlFor="fileType">Tipo de Archivo:</label>
          <select
            id="fileType"
            value={fileType}
            onChange={(e) => setFileType(e.target.value as 'justo' | 'uber')}
            disabled={loading}
          >
            <option value="justo">Justo</option>
            <option value="uber">Uber</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="file">Seleccionar Archivo Excel:</label>
          <input
            type="file"
            id="file"
            accept=".xls,.xlsx"
            onChange={handleFileChange}
            disabled={loading}
          />
          {file && <p className="file-name">Archivo seleccionado: {file.name}</p>}
        </div>

        <button type="submit" disabled={loading || !file}>
          {loading ? 'Procesando...' : 'Subir Archivo'}
        </button>

        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
      </form>
    </div>
  );
};

export default FileUpload; 